<div class="d-f jc-sb ai-c mb-xxs">
	<app-tab [tabs]="policiesTabs" (action)="onTabClick($event)"></app-tab>
	<button mat-flat-button color="primary" routerLink="cadastro">
		<mat-icon>add</mat-icon>
		<span class="no-mob">Nova política</span>
	</button>
</div>
<div class="d-f jc-c ai-c w-100 loader" *ngIf="loading$ | async">
	<mat-spinner diameter="20"></mat-spinner>
</div>
<div class="d-f jc-fs" *ngIf="(loading$ | async) === false && !policies.length">
	<p class="fs-xs lh-xs fs-i gray">Nenhuma política cadastrada</p>
</div>
<ng-container *ngIf="(loading$ | async) === false">
	<div
		class="pos-r mb-xxxs pb-nano br-md card"
		*ngFor="let policy of policies; let index = index"
	>
		<div class="d-f ai-c mt-xxxs mb-nano ml-xxxs br-md">
			<div class="d-f fd-c jc-c col">
				<span class="fs-xxxs fw-bold lh-xxxs gray">Política</span>
				<span class="mt-quark fs-xs lh-xs to-ellipsis">{{ policy.name }}</span>
			</div>
			<div class="d-f fd-c jc-c col no-mob">
				<span class="fs-xxxs fw-bold lh-xxxs gray">Forma de contratação</span>
				<span class="mt-quark fs-xs lh-xs">
					{{ policy.contract | titlecase }}
				</span>
			</div>
			<div class="d-f jc-c ai-c mr-nano c-p squared" [matMenuTriggerFor]="menu">
				<mat-icon svgIcon="sanus-more-blue"></mat-icon>
			</div>
		</div>
		<mat-menu #menu="matMenu">
			<button mat-menu-item (click)="onEditPolicy(policy.id)">
				Editar política
			</button>
			<button mat-menu-item (click)="onDeletePolicy(policy.id)">Excluir</button>
		</mat-menu>
	</div>
	<div class="pb-huge">&nbsp;</div>
</ng-container>
